<template>
    <div class="card bg-warn" v-if="notice.title || notice.value">
        <div class="card-body">
            <p class="mb-3">
            <span class="strong cardTitle">
              <u>{{ notice.title }}</u>
                <!--<u>～お客様へのお知らせ～</u>-->
            </span>
            </p>
            <p>
                <span class="strong" v-html="notice.value"></span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "NoticeBox",
    props: [
        'notice',
    ],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cardTitle {
    font-size: 1.4em;
}

.card {
    margin-top: 1em;
}

.bg-warn {
    background-color: #ffffcc;
}
</style>
